module.exports = __webpack_public_path__ + "static/media/digital-ocean.dabd0dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client-logos/digital-ocean.png
// module id = 271
// module chunks = 0